import { loadingReducer as loading } from 'redux-loading';
import { reducers as sharedReducers } from '@smorder/logic';

import appReducer from './app.reducers';
import filterReducer from './filter.reducers';
import messageReducer from './message.reducers';
import navigatorReducer from './navigator.reducers';
import noteReducer from './note.reducers';
import reportsReducer from './reports.reducers';

const reducers = {
  ...sharedReducers,
  app: appReducer,
  filter: filterReducer,
  loading,
  message: messageReducer,
  navigator: navigatorReducer,
  note: noteReducer,
  reports: reportsReducer,
};

export default reducers;
